import { colors, semantic, spacing } from "../design-system";
import { useNetworkStatus } from "../hooks/useNetworkStatus";
import { AppText } from "./AppText";
import { Icon } from "./Icon";

/**
 * Bandeau « hors connexion » — monté UNE fois au-dessus de toute l'app
 * (AppProviders), jamais écran par écran.
 *
 * ## Pourquoi global
 * L'app est entièrement dépendante du réseau (courses, wallet, suivi temps
 * réel). Sans signal explicite, une perte de réseau se traduisait par des
 * écrans vides ou des erreurs génériques, sans que l'utilisateur comprenne la
 * cause. Le bandeau apparaît quel que soit l'écran affiché.
 *
 * ## Il POUSSE, il ne recouvre pas
 * Un overlay flottant finit toujours par masquer un élément (nom, cloche,
 * pastille d'adresse…) selon l'écran affiché. Le bandeau occupe donc sa propre
 * bande en haut de l'app et décale le contenu — rien n'est jamais caché. Il
 * disparaît de lui-même dès le retour du réseau (`useNetworkStatus`).
 *
 * ⚠️ Fiabilité réduite sur web : `useNetworkStatus` s'appuie désormais sur
 * `navigator.onLine`, qui ne teste PAS la joignabilité réelle d'Internet.
 * Derrière un portail captif, le bandeau ne s'affichera pas alors que rien ne
 * passe. Détail du compromis dans hooks/useNetworkStatus.ts.
 */
export function OfflineBanner() {
  const isOnline = useNetworkStatus();

  if (isOnline) return null;

  return (
    <div
      role="alert"
      aria-label="Pas de connexion Internet"
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        gap: spacing.sm,
        backgroundColor: semantic.backgroundInverse,
        paddingTop: spacing.sm,
        paddingBottom: spacing.sm,
        paddingLeft: spacing.lg,
        paddingRight: spacing.lg,
      }}
    >
      <Icon name="cloud-offline" size={15} color={colors.white} />
      <AppText variant="smallBold" color={colors.white}>
        Pas de connexion Internet
      </AppText>
    </div>
  );
}
